<template>
  <header :class="s.header" :style="style">
    <div v-if="user.login.isLogin">
      <div :class="s.label">
        <div class="fs-5 text-center flex-grow-1">{{ page.label }}</div>
        <div
          class="me-0"
          @click="update"
          :class="s.update"><i class="fa-solid fa-rotate"/></div>
      </div>
    </div>
    <div v-else>
      <div :class="s.label">
        <div>MITT</div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'GlobalHeader',
  mixins: [cf],
  components: {
  },
  computed: {
    ...mapState(['user', 'helper']),
    page() {
      return cf.getPage(this.$route.path);
    },
    statusColor() {
      const officeId = this.user.offices?.[0]?.id;
      return this.getStatusHex(officeId, this.user.driverStatus?.name);
    },
    style() {
      return {
        '--status-color': this.statusColor,
      };
    },
  },
  methods: {
    update() {
      this.$store.dispatch('user/update');
    },
  },
};
</script>

<style lang="scss" module="s">
.header {
  position: fixed;
  top: 0;
  right: 0;
  margin: 0;
  z-index: 10;
  width: 100vw;
  height: var(--header-height);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #ffffff;
  background-color: var(--header-bg);
  height: var(--page-label-height);
  padding: 0 12px;
  position: relative;
}
.update {
  position: absolute;
  right: 10px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #ffffff;
}
</style>
